import { render, staticRenderFns } from "./WashyContainer.vue?vue&type=template&id=28068078&"
import script from "./WashyContainer.vue?vue&type=script&lang=js&"
export * from "./WashyContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports